import {preSignedUrl} from '@/api'



import axios from 'axios';

export const uploadFileToGCS =  (file,name) => {

    console.log(file)
    console.log(name)
    return new Promise( async(resolve,reject)=>{

        try {
            // 请求后端生成 Signed URL
            const response = await preSignedUrl({fileName:name})
            console.log('response')
            console.log(response)
            console.log('response')
            const  url = response.data;
    
            // 使用 Signed URL 上传文件
            const uploadResponse = await axios.put(url, file, {
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
            });
    
            if (uploadResponse.status === 200) {
                console.log(uploadResponse)
                console.log('File uploaded successfully!');
                resolve()
            } else {
                reject()
                console.error('File upload failed.');
            }
        } catch (error) {
            reject()
            console.error('Error uploading file:', error);
        }
    })
};



